export function getDisplayNamesFromPeoplePickerInTable(str, column) {
  const tableData = JSON.tryParse(str, []);
  let names = [];
  for (const row of tableData) {
    const userArray = JSON.tryParse(row[column], []);
    for (const user of userArray) {
      names.push(user.displayName);
    }
  }
  return names.join(", ");
}
